import { FunctionComponent, useState } from 'react'
import Dialog from '@/components/_custom/Dialog/Dialog.tsx'
import { useTranslation } from 'react-i18next'
import DialogHeader from '@/components/_custom/DialogHeader/DialogHeader.tsx'
import DialogBody from '@/components/_custom/DialogBody/DialogBody.tsx'
import styles from './confirmDeleteReservationDialog.module.scss'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon.tsx'
import { Close, Delete } from '@mui/icons-material'
import { useMutation } from '@apollo/client'
import { DELETE_RESERVATION_EVENT } from '@/modules/API/daycare/eventDayHandler.ts'
import TextArea from '@/components/_custom/TextArea/textArea.tsx'
import { useNotification } from '@/modules/context/NotificationContext.tsx'

interface ConfirmDeleteReservationProps {
    open: boolean
    handleClose: () => void
    daycareId: number
    reservationId: number
    refetchAllEvents: () => Promise<void>
}

const ConfirmDeleteReservationDialog: FunctionComponent<ConfirmDeleteReservationProps> = ({
    open,
    handleClose,
    daycareId,
    reservationId,
    refetchAllEvents
}: ConfirmDeleteReservationProps) => {
    const { t } = useTranslation()

    const { showNotificationSuccess, showNotificationError } = useNotification()

    const [parentComment, setParentComment] = useState<string>('')

    const [deleteReservation, { loading: loadingDelete }] = useMutation(DELETE_RESERVATION_EVENT, {
        variables: {
            daycare_id: daycareId,
            reservation_id: reservationId,
            comment: parentComment
        },
        onCompleted: () => {
            showNotificationSuccess(t('reservationDeleted'))

            refetchAllEvents()

            handleClose()
        },
        onError: () => {
            showNotificationError(t('errorReservationDeleted'))
        }
    })

    return (
        <Dialog open={open} handleClose={handleClose} className={styles.Dialog}>
            <DialogHeader title={t('deleteReservation')} parent={true} />
            <DialogBody className={styles.DialogBody}>
                <p className={styles.Text}>{t('deleteReservationMessage')}</p>
                <div className={styles.TextAreaInput}>
                    <p className={styles.TextAreaTitle}>{t('unbookReason')}</p>
                    <TextArea
                        placeholder={t('unbookReason')}
                        maxCount={200}
                        className={styles.TextArea}
                        value={parentComment}
                        onChange={setParentComment}
                        parent={true}
                    />
                </div>
                <div className={styles.ButtonContainer}>
                    <ButtonTextIcon
                        parent={true}
                        type={'custom'}
                        customText={t('yes')}
                        customIcon={<Delete />}
                        onClick={deleteReservation}
                        className={styles.Button}
                        disabled={loadingDelete}
                    />
                    <ButtonTextIcon
                        parent={true}
                        type={'custom'}
                        customText={t('no')}
                        customIcon={<Close />}
                        onClick={handleClose}
                        className={styles.Button}
                    />
                </div>
            </DialogBody>
        </Dialog>
    )
}

export default ConfirmDeleteReservationDialog
